import React, { useState, useEffect, useContext, useRef } from 'react';
import { useSelector } from 'react-redux';
import LoadingSpinner from 'src/components/common/LoadingSpinner';
import { IRootState } from 'src/reducers';
import Page from 'src/components/common/Page';
import Panel from 'src/components/common/Panel';
import { useFetch } from 'use-http';
import { DialogContext, dialogCreators } from 'src/providers/DialogProvider';
import Transmittal from 'src/models/dlcLease/Transmittal';
import TransmittalsList from './TransmittalsList';
import Tooltip from 'react-tooltip-portal';
import Button from 'src/components/controls/forms/redesign/FormButton';

const TransmittalsPage = () => {
    const appContext = useSelector((state: IRootState) => state.appContext);
    const { response, get } = useFetch();
    const dialogContext = useContext<dialogCreators>(DialogContext);
    
    // TODO: Look into setting up a ts file containing tool tips (similar to DialogName enum)
    const transmittalToolTip = 'Select "Manage" to update Transmittal and batch Lease Recordings';

    const [transmittalsList, setTransmittalsList] = useState<Array<Transmittal>>([]);

    // Tooltip states
    const transmittalRef = useRef(null);
    const [showTTip, setShowTTip] = useState<boolean>(false);

    useEffect(() => {
        getTransmittals();
    }, []);

    const getTransmittals = async () => {
        let result = await get(`/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/processingMaintenance/transmittal`);

        if (response.ok) {
            setTransmittalsList(result);
        } else {
            console.log('getTransmittals Error:', result);
            window.alert('Error getting Transmittals');
        }
    };
        
    const onTransmit = (transmittal?: Transmittal) => {
        dialogContext.processing.transmittals(transmittal, () => onUpdate());
    };

    const onUpdate = () => {
        getTransmittals();
    };

    const transmittalListWindow = () => {
        return (
            <Panel>
                <div className="dlc-content-panel-header">
                    <div>
                        <Button
                            intent="primary"
                            text="New Transmittal"
                            onClick={() => onTransmit()}
                            style={{ marginRight: '1rem' }}
                        />
                        <Button
                            intent="primary"
                            text="Group Invoices (WIP)"
                            style={{ marginRight: '1rem' }}
                            disabled={true}
                        />
                    </div>
                </div>
                <div className="dlc-content-panel-header">
                    <span>Transmittals</span>
                    <span
                        className="tool-tip"
                        ref={transmittalRef}
                        onMouseEnter={() => setShowTTip(true)}
                        onMouseLeave={() => setShowTTip(false)}
                    >
                        <i className="fa fa-info-circle" />
                    </span>
                    <Tooltip active={showTTip} parent={transmittalRef.current} position="top" className="tooltip">
                        <div>{transmittalToolTip}</div>
                    </Tooltip>
                </div>
                <div style={{ overflow: 'auto', maxHeight: '65vh' }}>
                    {!!transmittalsList && (
                        <TransmittalsList
                            transmittals={transmittalsList}
                            onUpdateTransmittal={onTransmit}
                        />
                    )}
                    {!transmittalsList && <LoadingSpinner />}
                </div>
            </Panel>
        );
    };

    return (
        <Page>
            <Page.Section>
                {transmittalListWindow()}
            </Page.Section>
        </Page>
    );
};

export default TransmittalsPage;


// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/ProcessingAndMaintenance/TransmittalsPage.tsx